import React, { useState, useEffect } from "react";
import {
    Box,
    Text,
    VStack,
    HStack,
    Image,
    Button,
    Divider,
    Avatar,
    Input,
    IconButton,
    useColorModeValue,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { FaPaperPlane } from "react-icons/fa";
import Layout from "../components/Layout/Layout";
import { fetchBlogPostById, addCommentToBlogPost } from "../api/mockBlogApi";

const BlogPostDetail = () => {
    const { id } = useParams();
    const [post, setPost] = useState(null);
    const [comments, setComments] = useState([]);
    const [newCommentContent, setNewCommentContent] = useState("");

    const textColor = useColorModeValue("gray.800", "white");
    const cardBg = useColorModeValue("gray.50", "gray.700");
    const inputBg = useColorModeValue("gray.100", "gray.600");

    useEffect(() => {
        const getBlogPost = async () => {
            const fetchedPost = await fetchBlogPostById(id);
            setPost(fetchedPost);
            if (fetchedPost) {
                setComments(fetchedPost.comments);
            }
        };
        getBlogPost();
    }, [id]);

    const handleAddComment = async () => {
        if (newCommentContent.trim() && post) {
            const result = await addCommentToBlogPost(post.id, newCommentContent);
            if (result.success) {
                setComments((prev) => [...prev, result.newComment]);
                setNewCommentContent("");
            } else {
                alert(result.message);
            }
        }
    };

    if (!post) {
        return (
            <Layout title="WAGER STREET BLOG">
                <Box p={4}>
                    <Text fontSize="xl" color={textColor}>Loading blog post...</Text>
                </Box>
            </Layout>
        );
    }

    return (
        <Layout title="WAGER STREET BLOG">
            <Box p={4}>
                <VStack align="start" spacing={6}>
                    {post.image && (
                        <Image
                            src={post.image}
                            alt={post.title}
                            maxH="400px"
                            objectFit="cover"
                            borderRadius="lg"
                            w="full"
                        />
                    )}
                    <Text fontSize="4xl" fontWeight="bold" color="purple.400">
                        {post.title}
                    </Text>
                    <HStack spacing={4} color="gray.500" fontSize="md">
                        <Text>By {post.author}</Text>
                        <Text>|</Text>
                        <Text>{post.date}</Text>
                    </HStack>
                    <Text fontSize="lg" color={textColor}>
                        {post.content}
                    </Text>

                    <Divider borderColor="gray.600" />

                    <Text fontSize="2xl" fontWeight="bold" color={textColor}>
                        Comments ({comments.length})
                    </Text>
                    <VStack spacing={4} align="stretch" w="full">
                        {comments.map((comment) => (
                            <HStack key={comment.id} align="start" spacing={3} p={3} bg={cardBg} borderRadius="md">
                                <Avatar src={comment.avatar} size="sm" />
                                <VStack align="start" spacing={0} flex={1}>
                                    <HStack>
                                        <Text fontWeight="semibold" color={textColor}>{comment.author}</Text>
                                        <Text fontSize="xs" color="gray.500">
                                            {comment.timestamp}
                                        </Text>
                                    </HStack>
                                    <Text fontSize="sm" color={textColor}>{comment.content}</Text>
                                </VStack>
                            </HStack>
                        ))}
                    </VStack>

                    <Box w="full" mt={4}>
                        <HStack>
                            <Input
                                placeholder="Add a comment..."
                                value={newCommentContent}
                                onChange={(e) => setNewCommentContent(e.target.value)}
                                bg={inputBg}
                                border="none"
                                _placeholder={{ color: "gray.400" }}
                                color={textColor}
                            />
                            <IconButton
                                icon={<FaPaperPlane />}
                                colorScheme="purple"
                                aria-label="Add comment"
                                onClick={handleAddComment}
                            />
                        </HStack>
                    </Box>
                </VStack>
            </Box>
        </Layout>
    );
};

export default BlogPostDetail;